<script lang="ts">
	import { computePosition, autoUpdate, flip, shift, offset, arrow } from '@floating-ui/dom';
	import { storePopup } from '$lib/actions/Popup/popup';
	import ToastMessages from '$lib/components/ToastMessage/ToastMessage.svelte';
	import '$lib/components/scrollbar/scrollbar.css';
	import { isUserDragging } from '$lib/stores/draggingStore';
	import { screenHeight, screenWidth, scrollY } from '$lib/stores/resizeStore';
	import '../app.css';
	import '$textEditor/styles.css';
	import { direction } from '$lib/stores/directionStore';

	storePopup.set({ computePosition, autoUpdate, flip, shift, offset, arrow });

	let delayed: ReturnType<typeof setTimeout> | null = null;
	const onDragOver = (e: { preventDefault: () => void }) => {
		e.preventDefault();
		if (delayed) {
			clearTimeout(delayed);
		}
		delayed = setTimeout(() => {
			$isUserDragging = false;
		}, 500);
		if ($isUserDragging) {
			return;
		}
		$isUserDragging = true;
	};
	const onDrop = () => {
		$isUserDragging = false;
	};
</script>

<div id="pageContainer" dir={$direction.toLowerCase()}>
	<slot />
	<ToastMessages />
</div>

<svelte:window
	bind:innerWidth={$screenWidth}
	bind:innerHeight={$screenHeight}
	bind:scrollY={$scrollY}
	on:dragover={onDragOver}
	on:drop={onDrop}
/>
